import React, {useState,useContext,useEffect,lazy,Suspense,useRef} from "react";
import {Loading,ColumDataTableReorganize,ProfilActionButton,TagArticleBtn,GenerateBarCodeBtnA4,ProfilParentRestockButton,articleDataGenerator,articleColumnGenerate,customFieldsColumnGenerate,priceSuppColumnGenerate,enumereColumnGenerate,articleEditionDatatable,ExportArticleButton,AddMarkExportForm,useLocalStorage,articlePriceUnitSuppDataGenerator} from '@gull'
import { useCookies} from 'react-cookie';
import { useTranslate } from 'react-redux-multilingual'
import axios from 'axios'
import swal from "sweetalert2";
import { IsAuthContext } from '../../../app/App';
// Divers
import {scrollXDataTable} from 'app/scrollXDataTable';
import {articleListErp} from 'app/columnsArticleListeDataTable';
import { devises_list } from "app/devises";
// Bootstrap
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import { Modal } from "react-bootstrap";

const CarouselImage = lazy(() => import('../carousel/CarouselImage'));

// Initialisation
const useLoad = (props) => {
    const t =useTranslate()
    // Datas
    const [sizeDatas,setSizeDatas]=useState(0)
    const [datas, setDatas]=useState([])
    // Loader
    const [loading,setLoading] = useState(true) 
    // Customfields
    const [customFields,setCustomFields]=useState(false)
    // Liaisons
    const [liaisons,setLiaisons]=useState(false)
    const [optionsDataTable,setOptionsDataTable]=useState({
        devise:[],
        marque:[],
        fournisseur:[],
        firstlevelcat:[],
        secondlevelcat:[],
        thirdlevelcat:[],
        fourthlevelcat:[],
        fifthlevelcat:[]

    })
    const [ourOptionsDataTable,setOurOptionsDataTable]=useState({
        devise:{},
        marque:{},
        fournisseur:{},
        firstlevelcat:{},
        secondlevelcat:{},
        thirdlevelcat:{},
        fourthlevelcat:{},
        fifthlevelcat:{}

    })
    // Filtre
    const [filtre,setFiltre] = useState({})
    
    // Customfields
    useEffect(function () {
        (async function() {
            const response = await axios.get(process.env.REACT_APP_API_URL+"api/custom_fields/all/article"
            ).then((response) => {
                setCustomFields(response.data.datas)
            }).catch((error) => {
                if(error=='end_session') return;
                let messageError
                if(error.response==undefined){
                    messageError='unknowError'
                }else if(error.response.status==403){
                    messageError='forbiddenGeneral'
                }else {
                    messageError='unknowError'
                }
                swal.fire(t(messageError), "", "error");
            })
        })()
    }, [])

    // Liaisons
    useEffect(function () {
        (async function() {
            const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/article/liaison"
            ).then((response) => {
                setLiaisons(response.data.datas)

                let arr = ['firstlevelcat','secondlevelcat','thirdlevelcat','fourthlevelcat','fifthlevelcat','fournisseur','marque']
                //on crée une zone de stockage temporaire des données avant de tout set
                let optionsDataTableTemp = optionsDataTable
                let ourOptionsDataTableTemp = ourOptionsDataTable
                
                //formatage des options du select dans le cell edit du datatable pour les devises
                let arrDevise=[]
                let objDeviseOur={}
                devises_list.map(value=>{
                    arrDevise.push({'value':value.name+" - "+value.code,'label':value.name+" - "+value.code})
                    objDeviseOur[value.name+" - "+value.code]=value.code
                })

                optionsDataTableTemp={...optionsDataTableTemp,devise:arrDevise}
                ourOptionsDataTableTemp={...ourOptionsDataTableTemp,devise:objDeviseOur}

                //formatage des options du select dans le cell edit du datatable pour le reste des colones
                arr.forEach(item=>{
                    let optionsArr = [{'value':t('emptyValue'),'label':t('emptyValue')}]
                    let ourOptionObj = {}

                    ourOptionObj[t('emptyValue')]=''
                    response.data.datas[item].map(value=>{
                        optionsArr.push({'value':value.name,'label':value.name})
                        ourOptionObj[value.name]=value.id
                    })

                    optionsDataTableTemp={...optionsDataTableTemp,[item]:optionsArr}
                    ourOptionsDataTableTemp={...ourOptionsDataTableTemp,[item]:ourOptionObj}
                })

                setOptionsDataTable(optionsDataTableTemp)
                setOurOptionsDataTable(ourOptionsDataTableTemp)
            }).catch((error) => {
                if(error=='end_session') return;
                let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
                swal.fire(t(errorName), "", "error");
            })
        })()
    }, [])

    // Datas
    useEffect(function () {
        (async function() {
            setLoading(true)
            const response = await axios.post(process.env.REACT_APP_API_URL+"api/pos/preparation/get_period_preparation_article/"+props.currentPage+"/"+props.perPage+"/"+props.periodStart+"/"+props.periodEnd,{
                ...props.urlParam,
                ...filtre
            }).then((response) => {
                if(response.data.valid){   
                    setDatas(response.data.datas)
                    setSizeDatas(response.data.count)
                    setLoading(false)
                }
                
            }).catch((error) => {
                if(error=='end_session') return;
                swal.fire(t('unknowError'), "", "error");
            })
            setLoading(false)
        })()
    }, [props.reload])

    return [sizeDatas,setSizeDatas,datas,setDatas,customFields,liaisons,loading,optionsDataTable,ourOptionsDataTable,filtre,setFiltre]
}

// Gestion datatable
const CustomDataTable = (props) => {
    const t = useTranslate();
    
    useEffect(() => {
        scrollXDataTable(window.screen.width,props.columns.length)
    }, [window.screen.width,props.columns.length]);
    
    return (
        <BootstrapTable
            {...props.propst.baseProps}
            bootstrap4
            remote
            pagination={ paginationFactory(props.paginationOptions) }
            onTableChange={ props.handleTableChange }
            noDataIndication={props.validButton ? <div className="spinner-border spinner-border-sm"></div> : t('tableNoData')}
            hover
            condensed
            responsive
        />
    );
};

const HistoriqueArticleListPreparation = (props) => {
    const t =useTranslate()
    const posid = useRef(props.posid);
    const [sizeDatas,setSizeDatas,datas,setDatas,customFields,liaisons,loading,optionsDataTable,ourOptionsDataTable,filtre,setFiltre]=useLoad(props)

    const [perPage,setPerPage] = useState(50)
    const [currentPage,setCurrentPage] = useState(1)
    const { authParam } = useContext(IsAuthContext)
    const [cookies, setCookie] = useCookies(['historique_preparation_pos_article_fields','historique_preparation_pos_article_reorganize']);
    const [localStorage, setLocalStorage] = useLocalStorage(['historique_preparation_pos_article_fields','historique_preparation_pos_article_reorganize']);
    useEffect(() => {//ce use effect permet de faire la transistion entre l'ancienne utilisation des cookies pour la gestion des datatable et la nouvell gestion via localStorage. Il faudra supprimer cela et l'utilisation des cookies à partir de juin 2026
        if(!localStorage.historique_preparation_pos_article_fields && cookies.historique_preparation_pos_article_fields){
            setLocalStorage('historique_preparation_pos_article_fields',cookies.historique_preparation_pos_article_fields);
        }
        if(!localStorage.historique_preparation_pos_article_reorganize && cookies.historique_preparation_pos_article_reorganize){
            setLocalStorage('historique_preparation_pos_article_reorganize',cookies.historique_preparation_pos_article_reorganize);
        }
    }, []);
    const [lang, setLang] = useCookies(['lang']);
    const [addMark,setAddMark]=useState(true) 
    const [headerColumnShowExport,setHeaderColumnShowExport]=useState('')
    let headerAllExport = (localStorage.historique_preparation_pos_article_reorganize) ? localStorage.historique_preparation_pos_article_reorganize.replace('action,masque,','') : 'all'

    // Conditionnement
    const maxConditionnement = (authParam.company.advanceparams.max_conditionnement!='' && authParam.company.advanceparams.max_conditionnement!=null) ? +authParam.company.advanceparams.max_conditionnement : 0
    // Prix supplémentaire
    const suppPrice = authParam.company.advanceparams.hasOwnProperty('prix_supplementaire') ? authParam.company.advanceparams.prix_supplementaire : []
    // Column de base du datatable (par defaut)
    let cookieLecture = ['internalid','name','quantity','reference','price','action'];
    if(localStorage.historique_preparation_pos_article_fields){
        let columnShowVar = localStorage.historique_preparation_pos_article_fields;
        cookieLecture = columnShowVar.split(',')
    }

    const [columnShow,setColumnShow] = useState(cookieLecture) 
    const [columnOrganizeArticle,setColumnOrganizeArticle]=useState([])
    const [showColumnOrganizeArticle,setShowColumnOrganizeArticle]=useState(false)

    //Pour le carousel (image)
    const [showCarousel,setShowCarousel]=useState(false) 
    const [modalItemName,setModalItemName]=useState('') 
    const [modalImage,setModalImage]=useState('') 
    
    // Date expiration cookie
    let current_date = new Date()
    let timestampdate = current_date.setDate(current_date.getDate() + 90)
    let expire_date = new Date(timestampdate)

    const modulePos = authParam.modules.find(value=>value.name=='pos')

    let devise = authParam.company.devise;
    let digit = (authParam.company.advanceparams.hasOwnProperty('ventilation_espece') && authParam.company.advanceparams.ventilation_espece.piece.find(piece=> +piece < 1)) ? 2 : 0;

    // Column a exporter
    useEffect(function () {
        let headerColumnShowExportArr = [] 
        
        columnOrganizeArticle.map(value=>{
            if(columnShow.includes(value.dataField)) headerColumnShowExportArr.push(value.dataField)
        })
        setHeaderColumnShowExport(headerColumnShowExportArr.join(',').replace('action,',''))
    }, [columnShow,columnOrganizeArticle])

    // Paramètre pour datatable
    // start
    const sizePerPageOptionRenderer = ({
        text,
        page,
        onSizePerPageChange
    }) => (
        <li
            key={ text }
            role="presentation"
            className="dropdown-item"
            onMouseDown={ (e) => {
                e.preventDefault();
                onSizePerPageChange(page);
                setPerPage(page)
            } }
        >
            <a
                href="#"
                tabIndex="-1"
                role="menuitem"
                data-page={ page }
                style={ { color: 'black' } }
            >
                { text }
            </a>
        </li>
    );

    let paginationOptions = {
        page:currentPage,
        paginationSize: 5,
        pageStartIndex: 1,
        firstPageText: t('tableFirst'),
        prePageText: t('tableBack'),
        nextPageText: t('tableNext'),
        lastPageText: t('tableLast'),
        nextPageTitle: t('tableNextTitle'),
        prePageTitle: t('tableBackTitle'),
        firstPageTitle: t('tableFistTitle'),
        lastPageTitle: t('tableLastTitle'),
        sizePerPageOptionRenderer,
        sizePerPage: perPage,
        showTotal: true,
        totalSize: sizeDatas
    };
    
    const headerSortingStyle = { backgroundColor: '#c8e6c9' };
    // end
    
    // Ouverture carousel image
    const openModalCarousel = (image,itemName) =>{
        setModalImage(image)
        setModalItemName(itemName)
        setShowCarousel(true)
    }

    // Fermeture carousel image
    const closeModalCarousel = () =>{
        setModalImage('')
        setModalItemName('')
        setShowCarousel(false)
    }

    // Formatage pour datatable article
    let dataTable = new Array
    datas.length!=0 && datas.forEach((value,ind)=>{
        let obj = {
            masque:'',
            id: value.id,
            devise:(value.devise_achat!=null) ? value.devise_achat : '',
            action:
                <span className="d-flex justify-content-between">
                    <ProfilActionButton  path={(posid.current) ? '/pos/'+posid.current+'/item-base/details/'+value.id : '/erp/article/edit/'+value.id}/>
                    <ProfilParentRestockButton optionModule={modulePos} value={value} path={(posid.current) ? '/pos/'+posid.current+'/automatic-restock/parent-item/'+value.id : '/erp/automatic-restock/parent-item/'+value.id}/>
                    <TagArticleBtn articleName={value.name} articlePrice={value.price} articleUpc={value.reference} article={value} from='pos'/>
                    {(value.reference!='' && value.reference!=null) && <GenerateBarCodeBtnA4 articles={[value]} devise={devise} icon='true'/>}
                </span>,
            quantity:value.quantity,
            index: ind + 1,
        }
        articleDataGenerator(obj,value,t,openModalCarousel)
        articlePriceUnitSuppDataGenerator(obj,value,suppPrice)
        if (customFields) {
            customFields.forEach((item,index)=>{
                if(value.custom_fields){
                    obj[item.name]=value.custom_fields[item.name]
                }
            })
        }

        for (let i=0; i<maxConditionnement; i++){
            let numeroEnumere = i+1
            obj['name_'+numeroEnumere]= (value.hasOwnProperty('name_'+numeroEnumere) && value['name_'+numeroEnumere]!=null) ? value['name_'+numeroEnumere] : ''
            obj['reference_'+numeroEnumere]= (value.hasOwnProperty('reference_'+numeroEnumere) && value['reference_'+numeroEnumere]!=null) ? value['reference_'+numeroEnumere] : ''
            obj['quantity_'+numeroEnumere]= (value.hasOwnProperty('quantity_'+numeroEnumere) && value['quantity_'+numeroEnumere]!=null) ? value['quantity_'+numeroEnumere] : ''
        }

        suppPrice.map((item,index)=>{
            let numero = index+1
            let margePrixSupp = (value.hasOwnProperty('margeN_'+item['designation_'+numero]) && value['margeN_'+item['designation_'+numero]]!=null && value['margeN_'+item['designation_'+numero]]!=0) ? value['margeN_'+item['designation_'+numero]] : 0

            let margePercentPrixSupp = (value.hasOwnProperty('margeP_'+item['designation_'+numero]) && value['margeP_'+item['designation_'+numero]]!=null && value['margeP_'+item['designation_'+numero]]!=0) ? value['margeP_'+item['designation_'+numero]] : 0


            obj['price_'+item['designation_'+numero]]= (value.hasOwnProperty('price_'+item['designation_'+numero]) && value['price_'+item['designation_'+numero]]!==null && value['price_'+item['designation_'+numero]]!=='') ? value['price_'+item['designation_'+numero]] : ''
            
            obj['price_'+item['designation_'+numero]+'_ttc']= (value.hasOwnProperty('price_'+item['designation_'+numero]+'_ttc') && value['price_'+item['designation_'+numero]+'_ttc']!==null && value['price_'+item['designation_'+numero]+'_ttc']!=='') ? value['price_'+item['designation_'+numero]+'_ttc'] : ''

            obj['margeN_'+item['designation_'+numero]]= margePrixSupp

            obj['margeP_'+item['designation_'+numero]]= margePercentPrixSupp
        })
        dataTable.push(obj)
    })

    // Recuperation columns datatable article
    let columnsInit =[
        {
            dataField: "action",
            text: "Actions",
            editable: false,
            headerClasses: 'head-action-row',
            classes: 'body-action-row',
        },
        {
            dataField: "internalid",
            text: t('internalId'),
            editable: false,
            hidden: (columnShow.includes("internalid")) ? false : true,
            sort: true,
            headerSortingStyle,
        },
        {
            dataField: "quantity",
            text: t('quantity'),
            editable: false,
            hidden: (columnShow.includes("quantity")) ? false : true,
            sort: true,
            headerSortingStyle,
        }
    ];
    let columns = new Array
    if (customFields) {
        columns=[
            ...columnsInit,
            ...articleColumnGenerate(articleListErp,columnShow,headerSortingStyle,articleEditionDatatable,optionsDataTable,ourOptionsDataTable,t,authParam),
            ...enumereColumnGenerate(maxConditionnement,columnShow,headerSortingStyle,articleEditionDatatable,t,authParam),
            ...priceSuppColumnGenerate(suppPrice,columnShow,headerSortingStyle,articleEditionDatatable,t,authParam),
            ...customFieldsColumnGenerate(customFields,columnShow,headerSortingStyle,articleEditionDatatable,t,authParam),
        ]
    }

    useEffect(function () {
        let columnCookieArticle
        let arrColArticle = []

        if (customFields) {
            if(localStorage.historique_preparation_pos_article_reorganize){
                let newValueToIncludeInCookie
                let cookieLecture = localStorage.historique_preparation_pos_article_reorganize.split(',')
    
                let already_done=[];
                cookieLecture.map(value=>{
                    columns.map(item=>{
                        if(item.dataField==value){
                            arrColArticle.push(item)
                            already_done.push(value);
                        }
                    })
                })
                columns.map(item=>{
                    if(!already_done.includes(item.dataField)){ 
                        //si une nouvelle à été ajouté aux customsField, elle n'est pas ajoutée desuite au cookie de reorganisation si celui ci existe
                        //dans le cas où il n'existerait pas, on va créer un nouveau cookie afin de l'inclure pour ne pas avoir d'erreur sur les export 
                        newValueToIncludeInCookie=true
                        arrColArticle.push(item);
                    }
                })
    
                columnCookieArticle = arrColArticle
                if(newValueToIncludeInCookie==true){ 
                    let arr = []
                    arrColArticle.map(value=>
                        arr.push(value.dataField)
                    )
                    setLocalStorage('historique_preparation_pos_article_reorganize',arr.join(),{ path: "/", expires: expire_date })
                }
            }else{
                columnCookieArticle = columns
            } 
            setColumnOrganizeArticle(columnCookieArticle)
        }
    },[customFields,optionsDataTable,ourOptionsDataTable])

    useEffect(function () {
        if (customFields) {
            if(localStorage.historique_preparation_pos_article_fields){
                let cookieColumnShow = localStorage.historique_preparation_pos_article_fields.split(',')
                let columnsDatas = [] //contient toutes les dataFields de columns
                let arrColumnShow = [] //contient toutes les données sans doublons
                let arrColumnShowDoublon = [] //contient les doublons
                let arrColumnShowIntrus = [] // continent les fausse données

                columns.map(item=>{
                    columnsDatas.push(item.dataField)
                })

                cookieColumnShow.map(value=>{
                    //on vérifie si le cookie contien des doublons
                    if(!arrColumnShow.includes(value)){
                        arrColumnShow.push(value)
                    }else{
                        //Si value existe dejà c'est qu'il y a un doublon 
                        arrColumnShowDoublon.push(value)
                    }
                    //on vérifie si les données du cookies sont des données qui exisent dans le tableau columns
                    if(!columnsDatas.includes(value)) arrColumnShowIntrus.push(value)
                    
                })

                if(arrColumnShowDoublon.length!=0 || arrColumnShowIntrus.length!=0){ 
                    //Si le cookie contient des doublons et des données qui n'existe pas en meme temps
                    let uniformData = arrColumnShow.filter(value=> !arrColumnShowIntrus.includes(value))

                    setLocalStorage("historique_preparation_pos_article_fields",uniformData.join(),{ path: "/", expires: expire_date })
                }
            }
        }
    }, [customFields])

    const handleToggleColumns = (column,indexToEdit) => {
        if(column.toggle){
            var newColumnShow = columnShow.filter(value=>value!=column.dataField)

            //Modification pour la mise à jour des status hidden de chaque colonnes
            let dataColumn = columnOrganizeArticle.filter(value=>value.dataField!=column.dataField)
            let newData = column
            newData.hidden = true

            dataColumn.splice(indexToEdit,0, newData)

            setColumnOrganizeArticle(dataColumn)
            //End

            setColumnShow(newColumnShow)
            
        }
        else{
            var newColumnShow = [...columnShow,column.dataField]

            //Modification pour la mise à jour des status hidden de chaque colonnes
            let dataColumn = columnOrganizeArticle.filter(value=>value.dataField!=column.dataField)
            let newData = column
            newData.hidden = false

            dataColumn.splice(indexToEdit,0, newData)

            setColumnOrganizeArticle(dataColumn)
            //End

            setColumnShow(newColumnShow)
        }
        setLocalStorage("historique_preparation_pos_article_fields",newColumnShow.join(),{ path: "/", expires: expire_date }) 
    }

    const handleTableChange = async (type, { page, sizePerPage, sortField, sortOrder }) => {
        let objFiltre 

        if(type=='sort'){
            objFiltre = {
                ...filtre,
                sortField:sortField,
                sortOrder:sortOrder
            }
            setFiltre(objFiltre)
        }else{
            objFiltre = filtre
        }
        setPerPage(sizePerPage)
        const response = await axios.post(process.env.REACT_APP_API_URL+"api/pos/preparation/get_period_preparation_article/"+page+"/"+sizePerPage+"/"+props.periodStart+"/"+props.periodEnd,{
            ...props.urlParam,
            ...objFiltre
        }).then((response) => {
            if(response.data.valid){   
                setDatas(response.data.datas)
                setSizeDatas(response.data.count)
                setCurrentPage(page)
            }
        }).catch((error) => {
            if(error=='end_session') return;
            swal.fire(t('unknowError'), "", "error");
        })
    }

    if(!customFields || !liaisons){
        return (<span className="d-flex justify-content-center mb-3"><div className="spinner-border spinner-border-sm"></div></span>);
    }
    
    return(
        <>
            <Modal show={showCarousel} onHide={()=>closeModalCarousel()}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalItemName}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {showCarousel ?
                        <Suspense fallback={<Loading></Loading>}>
                            <CarouselImage images={modalImage} />
                        </Suspense>
                    :
                        false
                    }
                </Modal.Body>
            </Modal>
            <>
                {columnOrganizeArticle.length!=0 &&
                    <ToolkitProvider
                    keyField="index"
                    data={ dataTable }
                    columns={ columnOrganizeArticle }
                    columnToggle
                    >
                    {(propst) => (
                        <>
                            <div className="mb-2 d-flex alignt-items-baseline">
                                <div>
                                    <ColumDataTableReorganize 
                                        columnOrganize={columnOrganizeArticle}
                                        setColumnOrganize={setColumnOrganizeArticle}
                                        setCookie={setLocalStorage}
                                        cookieName='historique_preparation_pos_article_reorganize'
                                        showColumnOrganize={showColumnOrganizeArticle}
                                        setShowColumnOrganize={setShowColumnOrganizeArticle}
                                        executWhenToggle={handleToggleColumns}
                                        { ...propst.columnToggleProps }
                                        btnSwitch={true}//pour affiche ou non le btn swith
                                        initSwith={false}//initialier à false il affichera par défaut le toggle des colonnes, sur true il affichera le drag and drop pour changer la position des colonnes
                                    />&nbsp;&nbsp;&nbsp;
                                </div>
                                <ExportArticleButton lang={lang.lang} addMark={addMark} filtre={props.urlParam} header={headerColumnShowExport} title={t('downloadCSVSelection')} type="button" url={"api/pos/preparation/export_articles/"+props.periodStart+'/'+props.periodEnd}></ExportArticleButton>&nbsp;&nbsp;&nbsp;
                                <ExportArticleButton lang={lang.lang} addMark={addMark} filtre={props.urlParam} header={headerAllExport} title={t('downloadCSVAll')} type="button" url={"api/pos/preparation/export_articles/"+props.periodStart+'/'+props.periodEnd}></ExportArticleButton>&nbsp;&nbsp;&nbsp;
                                <div className="d-flex align-self-start">
                                    <AddMarkExportForm setAddMark={setAddMark} addMark={addMark} />
                                </div>
                            </div>
                            <small>
                                <div className="position-relative">
                                    <CustomDataTable
                                        propst={propst}
                                        paginationOptions={paginationOptions}
                                        handleTableChange={handleTableChange}
                                        validButton={props.validButton}
                                        columns={columnShow}
                                    />
                                </div>
                            </small>
                        </>
                    )}
                    </ToolkitProvider>
                }
            </> 
        </>
    )
    
}

export default HistoriqueArticleListPreparation;
